module.exports = __webpack_public_path__ + "media/images/logo__cleeksgc-234728ec094f8f7b5dc83cd1732bbee9.png";